import { TOKENKU_VOICE } from "./useTTS";

const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));
const BREAK = /(\s[—–]\s|,\s|;\s|:\s)/;
const PAUSE = { comma: 140, dash: 420, sentence: 320, line: 520 };

export const stripMarks = (s = "") => s.replace(/\*([^*]+)\*/g, "$1");

const phrasesOf = (sentence) => {
  const out = [];
  let buf = "";
  sentence.split(BREAK).forEach((p) => {
    if (BREAK.test(p) && /^(\s[—–]\s|,\s|;\s|:\s)$/.test(p)) {
      const dash = /[—–]/.test(p);
      out.push({ text: dash ? buf : buf + p.trim(), brk: dash ? "dash" : "comma" });
      buf = "";
    } else buf += p;
  });
  if (buf.trim()) out.push({ text: buf, brk: "sentence" });
  const merged = [];
  out.filter((p) => p.text.trim()).forEach((p) => {
    const prev = merged[merged.length - 1];
    if (prev && prev.brk === "comma" && stripMarks(prev.text).length < 18) {
      prev.text = `${prev.text} ${p.text}`;
      prev.brk = p.brk;
    } else merged.push({ ...p });
  });
  return merged;
};

// Turns one script line into speakable segments with their own pitch, rate and pause.
export function planLine(line, lineIdx, totalLines) {
  const sentences = line.split(/(?<=[.!?])\s+/).filter(Boolean);
  const segs = [];
  const lineLift = lineIdx === 0 ? 0.06 : lineIdx === totalLines - 1 ? -0.03 : (lineIdx % 2 ? 0.03 : -0.02);
  const lineSlow = lineIdx === totalLines - 1 ? -0.04 : 0;
  let afterDash = false;

  sentences.forEach((sentence, si) => {
    const end = sentence.trim().slice(-1);
    const phrases = phrasesOf(sentence);
    phrases.forEach((ph, pi) => {
      const first = pi === 0;
      const last = pi === phrases.length - 1;
      let pitch = TOKENKU_VOICE.pitch + lineLift + (pi % 2 ? -0.04 : 0.03);
      let rate = TOKENKU_VOICE.rate + lineSlow;
      if (first && si === 0) { pitch += 0.07; rate += 0.04; }
      if (afterDash) { pitch += 0.12; rate -= 0.04; }
      if (last && end === ".") { pitch -= 0.12; rate -= 0.05; }
      if (last && end === "!") pitch += 0.18;
      if (last && end === "?") pitch += 0.22;

      const pauseEnd = last
        ? si === sentences.length - 1 ? PAUSE.line : PAUSE.sentence
        : ph.brk === "dash" ? PAUSE.dash : PAUSE.comma;

      const parts = ph.text.split(/(\*[^*]+\*)/).filter((p) => /[\p{L}\p{N}]/u.test(p));
      parts.forEach((part, k) => {
        const emph = /^\*[^*]+\*$/.test(part.trim());
        const isLast = k === parts.length - 1;
        segs.push({
          text: stripMarks(part).replace(/^[\s,;:]+/, "").trim(),
          line: lineIdx,
          pitch: clamp(emph ? pitch + 0.24 : pitch, 0.6, 1.9),
          rate: clamp(emph ? rate - 0.1 : rate, 0.6, 1.3),
          volume: TOKENKU_VOICE.volume,
          pauseBefore: emph ? 110 : 0,
          pauseAfter: isLast ? pauseEnd : emph ? 90 : 0,
        });
      });
      afterDash = ph.brk === "dash";
    });
  });
  return segs;
}

export const planScript = (lines) => lines.flatMap((l, i) => planLine(l, i, lines.length));
